class Carousel extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector(".js-carousel-slider");
    this.sliderId = this.id;
    this.enableSliderAutoplay = this.getAttribute("data-slider-autoplay") == "true" ? true : false;
    this.autoplaySpeed = this.getAttribute("data-slider-autoplay-speed") ? parseFloat(this.getAttribute("data-slider-autoplay-speed")) : 3000;
    this.prevButtons = this.querySelectorAll('button[name="previous"]');
    this.nextButtons = this.querySelectorAll('button[name="next"]');
    this.trackers = this.querySelectorAll(".js-carousel-tracker");
    this.dots = this.querySelectorAll(".js-carousel-dots");
    this.vertical = this.classList.contains("carousel--vertical") ? true : false;
    this.delayInit = this.getAttribute("data-delay-init") == "true" ? true : false;
    this.thumbSlider = this.getAttribute("data-slider-thumb") ? document.getElementById(this.getAttribute("data-slider-thumb")) : null;

    if (!this.slider) return;

    if (this.enableSliderAutoplay) this.autoplay();

    if (this.delayInit) {
      this.addEventListener("trigger-init", () => {
        this.initPages();
      });
    } else {
      this.initPages();
      //console.log("initPages called for", this);
    }

    const resizeObserver = new ResizeObserver(() => this.initPages());
    resizeObserver.observe(this.slider);

    this.runTracker;
  }

  checkScreenSize() {
    if (window.innerWidth < 990 && this.classList.contains("carousel--vertical")) {
      this.vertical = false;
    }
    if (window.innerWidth > 991 && this.classList.contains("carousel--vertical")) {
      this.vertical = true;
    }
  }

  initPages() {
    this.checkScreenSize();
    this.sliderItems = this.querySelectorAll(`#${this.sliderId} > .js-carousel-slider > .js-carousel-slide`);
    this.slider.addEventListener("scroll", this.update.bind(this));
    if (this.prevButtons.length) {
      this.prevButtons.forEach((button) => {
        button.addEventListener("click", this.onButtonClick.bind(this));
      });
    }

    if (this.nextButtons.length) {
      this.nextButtons.forEach((button) => {
        button.addEventListener("click", this.onButtonClick.bind(this));
      });
    }

    if (this.getAttribute("data-slider-for")) {
      const mainSlider = document.getElementById(this.getAttribute("data-slider-for"));
      this.sliderItems.forEach((slide) => {
        slide.addEventListener("click", () => {
          this.sliderItems.forEach((item) => {
            item.classList.remove("active");
          });
          slide.classList.add("active");
          mainSlider.scrollToSlide(slide.getAttribute("data-slide-index"));
        });
      });
    }

    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);

    if (this.sliderItemsToShow[1] && this.sliderItemsToShow[0]) {
      if (this.vertical) {
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;

        this.slidesPerPage = Math.floor(this.slider.clientHeight / this.sliderItemOffset);
      } else {
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset) + 1;
      }

      if (this.classList.contains("carousel--show-to-edge") || this.classList.contains("carousel--mini-cart") || this.classList.contains("carousel--complete-set") || this.classList.contains("carousel--predictive-search")) {
        this.slidesPerPage -= 1;
      }
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    }

    this.update();

    if (this.dots.length) {
      this.initDots();
    }

    if (this.vertical) {
      this.updateThumbButtons();
    }
  }

  update() {
    if (this.vertical) {
      this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;
    } else {
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    }

    let currentSlide = this.currentPage;

    this.sliderItemsToShow.forEach((item, index) => {
      let thisSlide = index + 1;

      if (this.isSlideVisible(item) && thisSlide < currentSlide) {
        currentSlide = thisSlide;
      }
    });

    if (this.dots.length) {
      this.updateNextDot(currentSlide);
    }

    if (this.prevButtons.length) {
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && !(this.currentPage > 1)) {
        this.prevButtons.forEach((button) => {
          button.setAttribute("disabled", "disabled");
        });
      } else {
        this.prevButtons.forEach((button) => {
          button.removeAttribute("disabled");
        });
      }
    }

    if (this.nextButtons.length) {
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]) && !!this.sliderItemsToShow[this.sliderItemsToShow.length - 1].classList.contains("active")) {
        this.nextButtons.forEach((button) => {
          button.setAttribute("disabled", "disabled");
        });
      } else {
        this.nextButtons.forEach((button) => {
          button.removeAttribute("disabled");
        });
      }
    }

    if (this.trackers.length) {
      clearTimeout(this.runTracker);
      this.runTracker = setTimeout(() => {
        this.updateTracker();
      }, 50);
    }

    if (this.dots.length) {
      setTimeout(() => {
        this.updateDots(currentSlide);
      }, 250);
    }

    if (this.thumbSlider) {
      this.updateThumb(currentSlide);
    }
  }

  isSlideVisible(element, offset = 0) {
    if (element) {
      if (this.vertical) {
        const lastVisibleSlide = Math.ceil(this.slider.clientHeight + this.slider.scrollTop - offset);
        return element.offsetTop + element.clientHeight <= lastVisibleSlide && element.offsetTop >= this.slider.scrollTop;
      } else {
        const lastVisibleSlide = Math.ceil(this.slider.clientWidth + this.slider.scrollLeft - offset);
        return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
      }
    }
  }

  scrollToSlide(slide) {
    this.slideScrollPosition = slide * this.sliderItemOffset;
    if (this.vertical) {
      this.slider.scrollTo({
        top: this.slideScrollPosition,
      });
    } else {
      this.slider.scrollTo({
        left: this.slideScrollPosition,
      });
    }
  }

  initDots() {
    //init dots if element is present in the carousel
    //dots are outputted per slide but then hidden as there might be multiple items per slide
    this.dots.forEach((dotElem) => {
      const allDots = dotElem.querySelectorAll("span");

      if (!allDots.length) {
        for (let i = 0; i <= this.totalPages; i++) {
          if (dotElem.classList.contains("js-carousel-timer")) {
            dotElem.innerHTML += "<span><svg height='30' width='30'><circle class='circle' cx='15' cy='15' r='10'/></svg></span>";
          } else {
            dotElem.innerHTML += "<span></span>";
          }
        }
      }

      for (let index = 0; index < allDots.length; index++) {
        if (index >= this.totalPages) {
          allDots[index].style.display = "none";
        } else if (index === this.totalPages - 1 && window.innerWidth > 1800 && (this.classList.contains("carousel--show-to-edge") || this.classList.contains("carousel--mini-cart") || this.classList.contains("carousel--complete-set") || this.classList.contains("carousel--predictive-search"))) {
          allDots[index].style.display = "none";
        } else {
          allDots[index].style.display = "block";
        }

        allDots[index].addEventListener("click", () => this.scrollToSlide(index));
      }
    });
  }

  updateNextDot(slide) {
    //add next class to slide dot to grow in width
    this.dots.forEach((dotElem) => {
      const allDots = dotElem.querySelectorAll("span");

      allDots.forEach((dot) => {
        dot.classList.remove("next");
      });

      if (allDots[slide - 1]) {
        allDots[slide - 1].classList.add("next");
      }
    });
  }

  updateDots(slide) {
    //updates active part to display which slide is visible
    this.dots.forEach((dotElem) => {
      const allDots = dotElem.querySelectorAll("span");

      allDots.forEach((dot) => {
        dot.classList.remove("active");
      });

      if (allDots[slide - 1]) {
        allDots[slide - 1].classList.add("active");
      }
    });
  }

  updateTracker() {
    let lastSlideVisible = 0;
    this.sliderItemsToShow.forEach((item, index) => {
      if (this.isSlideVisible(item)) {
        lastSlideVisible = index + 1;
      }
    });

    let percentage = (lastSlideVisible / this.sliderItemsToShow.length) * 100;

    this.trackers.forEach((tracker) => {
      tracker.style.width = percentage + "%";
    });
  }

  onButtonClick(event, autoplay = false) {
    if (!autoplay) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }

    const step = event?.currentTarget?.dataset?.step || 1;
    if (this.vertical) {
      this.slideScrollPosition = event.currentTarget.name === "next" ? this.slider.scrollTop + step * this.sliderItemOffset : this.slider.scrollTop - step * this.sliderItemOffset;
    } else {
      this.slideScrollPosition = event.currentTarget.name === "next" ? this.slider.scrollLeft + step * this.sliderItemOffset : this.slider.scrollLeft - step * this.sliderItemOffset;
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]) && event.currentTarget.name == "next") {
      if (this.vertical) {
        this.slider.scrollTo({
          top: 0,
        });
      } else {
        this.slider.scrollTo({
          left: 0,
        });
      }
    } else {
      if (this.vertical) {
        this.slider.scrollTo({
          top: this.slideScrollPosition,
        });
      } else {
        this.slider.scrollTo({
          left: this.slideScrollPosition,
        });
      }
    }
  }

  autoplay() {
    setInterval(() => {
      this.onButtonClick(
        {
          currentTarget: {
            name: "next",
          },
        },
        true,
      );
    }, this.autoplaySpeed);
  }

  updateThumb(slide) {
    if (typeof this.thumbSlider.scrollToSlide == "undefined") return;
    this.thumbSlider.scrollToSlide(slide - 1);
  }

  updateThumbButtons() {
    const isTouch = window.matchMedia("(max-width: 989px)").matches;
    const marginProperty = isTouch ? "marginLeft" : "marginTop";
    const marginValue = isTouch ? "16" : "8";

    if (this.sliderItemsToShow.length <= this.slidesPerPage) {
      this.prevButtons.forEach((button) => {
        // button.classList.add("hidden");
      });

      this.nextButtons.forEach((button) => {
        //button.classList.add("hidden");
      });

      this.sliderItems[0].style[marginProperty] = `${marginValue}px`;
    }
  }
}

customElements.define("carousel-slider", Carousel);
